import React from "react";
import './App.css';

const Footer = () => {
    return (     <section className="footer" id="footer">
    <h1>Christian Emiyah</h1>
    <a>Software Engineer/Data Scientist</a>
    <a href="mailto:christian.emiyah@gmail.com">christian.emiyah@gmail.com</a>
    <a href="https://github.com/emichris" title="GitHub">Github: @emichris</a> 
    <a href="https://www.linkedin.com/in/christian-emiyah-17a5725b/" title="LinkedIn">LinkedIn: Christian.Emiyah</a> 
</section>
)};

export default Footer;